import { LMFeature } from "@livingmap/core-mapping";
import { RouteDestination } from "../redux/services/types";
import { SourceIds } from "../components/Map/plugins/types";
import { routeDestinationName } from "./routeDestinationName";

export const createRouteDestinationFeature = (
  destination: RouteDestination,
  language: string,
): LMFeature => {
  const id =
    destination.lmId || String(destination.featureId || "route-destination");
  const geometry: GeoJSON.Point = {
    type: "Point",
    coordinates: [destination.longitude, destination.latitude],
  };
  return new LMFeature({
    type: "Feature",
    id,
    geometry,
    properties: {
      geom: geometry,
      floor_id: destination.floorId,
      lm_id: id,
      uid: id,
      is_geojson: true,
      geom_type: "POINT",
      is_label_shown: true,
      name: routeDestinationName(destination, language),
    },
    layer: { id: "custom", type: "symbol", source: SourceIds.LM_SOURCE_ID },
    state: {},
    source: SourceIds.LM_SOURCE_ID,
  } as any);
};
